export default __webpack_public_path__ + "d4d6daff902201ba19dc95106bd751f9.webp";